import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import Carrusel360 from '../components/Carrusel360';
import ProductoPublicModel from '../models/ProductoPublicModel';
import CafeVerdePublicModel from '../models/CafeVerdePublicModel';
import TourPublicModel from '../models/TourPublicModel';
import vid1 from '../assets/vd1.mp4';
import vid2 from '../assets/vd2.mp4';
import vid3 from '../assets/vd3.mp4';
import vid4 from '../assets/vd4.mp4';

// IMPORTAMOS IMÁGENES LOCALES
import fincaImg from '../assets/finca.jpg';
import romanImg from '../assets/roman-catador.jpg';
import historiaImg from '../assets/historia-familia.jpg';
import cocinaHumoImg from '../assets/cocina-humo.jpg';
import bosqueImg from '../assets/bosque.jpg';
import xicotepecImg from '../assets/xicotepec.jpg';

const Home = () => {
  const [featuredProducts, setFeaturedProducts] = useState([]);
  const [greenCoffeeVarieties, setGreenCoffeeVarieties] = useState([]);
  const [loading, setLoading] = useState(true);
  
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    date: '',
    people: '2',
    message: '',
    includeBuffet: false,
    includeCatacion: true,
    includeRecorrido: true
  });

  const [contactData, setContactData] = useState({
    name: '',
    email: '',
    company: '',
    phone: '',
    tonnage: '1',
    quality: '',
    message: ''
  });

  useEffect(() => {
    cargarDatosInicio();
  }, []);

  const cargarDatosInicio = async () => {
    setLoading(true);
    try {
      // Cargar productos destacados
      const productos = await ProductoPublicModel.getDestacados();
      setFeaturedProducts(productos.length > 0 ? productos : [
        {
          id: 1,
          nombre: 'Café Premium Altura',
          descripcion_corta: 'Grano seleccionado de nuestras mejores cosechas',
          precio: 250,
          imagen_portada: 'https://images.unsplash.com/photo-1442512595331-e89e73853f31',
          categoria: 'Café en Grano'
        },
        {
          id: 2,
          nombre: 'Licor de Café Artesanal',
          descripcion_corta: 'Elaborado con nuestra receta familiar',
          precio: 350,
          imagen_portada: 'https://images.unsplash.com/photo-1514432324607-a09d9b4aefdd',
          categoria: 'Licor'
        },
        {
          id: 3,
          nombre: 'Bombones de Café',
          descripcion_corta: 'Chocolate relleno con crema de café',
          precio: 180,
          imagen_portada: 'https://images.unsplash.com/photo-1461023058943-07fcbe16d735',
          categoria: 'Bombones'
        },
        {
          id: 4,
          nombre: 'Galletas de Café',
          descripcion_corta: 'Horneadas con nuestra receta secreta',
          precio: 120,
          imagen_portada: 'https://images.unsplash.com/photo-1495474472287-4d71bcdd2085',
          categoria: 'Galletas'
        }
      ]);

      // Cargar variedades de café verde
      const verde = await CafeVerdePublicModel.getDisponibles();
      setGreenCoffeeVarieties(verde.length > 0 ? verde : [
        {
          nombre: 'Oro Natural Superior',
          origen: 'Xicotepec de Juárez, Puebla, México',
          altitud: '1,400 - 1,600 msnm',
          perfil_taza: 'Chocolate, nuez, caramelo'
        },
        {
          nombre: 'Oro PL-10',
          origen: 'Chiapas, México',
          altitud: '1,500 - 1,800 msnm',
          perfil_taza: 'Cítrico, floral, miel'
        },
        {
          nombre: 'Oro PL-20',
          origen: 'Oaxaca, México',
          altitud: '1,600 - 2,000 msnm',
          perfil_taza: 'Frutos rojos, vino tinto'
        },
        {
          nombre: 'Altura Premium',
          origen: 'Puebla, México',
          altitud: '1,700 - 2,100 msnm',
          perfil_taza: 'Chocolate amargo, especias'
        }
      ]);
    } catch (error) {
      console.error('Error cargando datos de inicio:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleTourSubmit = async (e) => {
    e.preventDefault();
    
    const numPersonas = parseInt(formData.people);
    const costoCatacion = formData.includeCatacion ? 200 * numPersonas : 0;
    const costoRecorrido = formData.includeRecorrido ? 150 * numPersonas : 0;
    const costoTourCompleto = formData.includeCatacion && formData.includeRecorrido ? 300 * numPersonas : costoCatacion + costoRecorrido;
    const costoBuffet = formData.includeBuffet && numPersonas >= 10 ? 200 * numPersonas : 0;
    const costoTotal = costoTourCompleto + costoBuffet;

    try {
      // Guardar en la base de datos
      await TourPublicModel.create({
        nombre: formData.name,
        email: formData.email,
        telefono: formData.phone,
        fecha_reserva: formData.date,
        personas: numPersonas,
        mensaje: formData.message,
        incluye_catacion: formData.includeCatacion,
        incluye_recorrido: formData.includeRecorrido,
        incluye_buffet: formData.includeBuffet
      });

      let mensaje = `¡Gracias por tu interés en visitar nuestra finca!\n\n`;
      mensaje += `📍 **Xicotepec de Juárez, Pueblo Mágico**\n`;
      mensaje += `🌲 **Sierra Norte de Puebla**\n\n`;
      mensaje += `📋 **RESUMEN DE TU RESERVACIÓN**\n`;
      mensaje += `━━━━━━━━━━━━━━━━━━━━━━━━\n\n`;
      mensaje += `👤 Nombre: ${formData.name}\n`;
      mensaje += `📧 Email: ${formData.email}\n`;
      mensaje += `📞 Teléfono: ${formData.phone}\n`;
      mensaje += `📅 Fecha: ${formData.date || 'Por definir'}\n`;
      mensaje += `👥 Personas: ${formData.people}\n\n`;
      
      mensaje += `💰 **DETALLE DE COSTOS**\n`;
      mensaje += `━━━━━━━━━━━━━━━━━━\n`;
      mensaje += `🎫 Tour Completo (${numPersonas} personas): $${costoTourCompleto} MXN\n`;
      
      if (formData.includeBuffet) {
        if (numPersonas >= 10) {
          mensaje += `🍽️ Cocina Tradicional de Humo: $${costoBuffet} MXN\n`;
        } else {
          mensaje += `⚠️ Cocina tradicional no incluida (mínimo 10 personas)\n`;
        }
      }
      
      mensaje += `\n💵 **TOTAL ESTIMADO: $${costoTotal} MXN**\n\n`;
      mensaje += `━━━━━━━━━━━━━━━━━━━━━━━━\n`;
      mensaje += `Te contactaremos en máximo 24 horas para confirmar disponibilidad.\n`;
      mensaje += `\n¡Gracias por elegir Román Valderrábano El Catador! ☕`;

      alert(mensaje);
    } catch (error) {
      alert('Hubo un error al procesar tu reservación. Por favor intenta de nuevo.');
    }
  };

  const handleContactSubmit = (e) => {
    e.preventDefault();
    
    let mensaje = `📦 **SOLICITUD DE COTIZACIÓN - CAFÉ VERDE**\n`;
    mensaje += `━━━━━━━━━━━━━━━━━━━━━━━━━━━━\n\n`;
    mensaje += `👤 Nombre: ${contactData.name}\n`;
    mensaje += `📧 Email: ${contactData.email}\n`;
    mensaje += `🏢 Empresa: ${contactData.company || 'No especificada'}\n`;
    mensaje += `📞 Teléfono: ${contactData.phone}\n`;
    mensaje += `📦 Cantidad: ${contactData.tonnage} tonelada(s)\n`;
    mensaje += `⚡ Calidad: ${contactData.quality || 'Por definir'}\n`;
    mensaje += `📝 Mensaje: ${contactData.message || 'Sin mensaje adicional'}\n\n`;
    mensaje += `━━━━━━━━━━━━━━━━━━━━━━━━━━━━\n`;
    mensaje += `Un asesor comercial te contactará en máximo 24 horas.\n`;
    mensaje += `Gracias por tu interés en Román Valderrábano El Catador.`;

    alert(mensaje);
    console.log('Contacto comercial:', contactData);
  };

  // Función para abrir redes sociales
  const openSocial = (url) => {
    window.open(url, '_blank', 'noopener noreferrer');
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
        <p>Cargando...</p>
      </div>
    );
  }

  return (
    <>
      <SEO 
        title="Román Valderrábano El Catador - Café de Especialidad desde 1880"
        description="Desde 1880 produciendo café de especialidad en la Sierra Norte de Puebla. Tours guiados por bosque mesófilo, catación con Q Grader y cocina tradicional de humo en Xicotepec, Pueblo Mágico."
        keywords="Román Valderrábano, El Catador, café de especialidad Xicotepec, café Puebla, catador Q Grader, café orgánico, tour cafetalero, cocina de humo"
        url="https://romanvalderrabanoelcatador.com/"
        image="https://romanvalderrabanoelcatador.com/og-home.jpg"
      />
      <div className="home">
        {/* Hero Section */}
        <section className="hero-section">
          <div className="hero-background"></div>
          <div className="hero-particles"></div>
          <div className="hero-content">
            <h1 className="hero-title">
              Román Valderrábano
              <span className="hero-subtitle">El Catador</span>
            </h1>
            <p className="hero-description">
              Desde 1880 cultivando los mejores granos de café en la Sierra Norte de Puebla. 
              Tradición familiar que ha pasado de generación en generación.
            </p>
            <p className="hero-description-small">
              <strong>ROMÁN VALDERRÁBANO, EL CATADOR</strong>, cuenta con la experiencia ancestral 
              de 5 generaciones y es catador Q Grader, para producir y procesar uno de los mejores 
              cafés del Estado de Puebla.
            </p>
            <div className="hero-buttons">
              <Link to="/products" className="btn btn-primary">
                <span>☕</span>
                Comprar Café
              </Link>
              <a href="#tour" className="btn btn-secondary" onClick={(e) => {
                e.preventDefault();
                document.getElementById('tour')?.scrollIntoView({ behavior: 'smooth' });
              }}>
                <span>🌿</span>
                Conoce Nuestro Recorrido
              </a>
            </div>
            <div className="hero-stats">
              <div className="stat-item">
                <span className="stat-number">1880</span>
                <span className="stat-label">Años de tradición</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">5</span>
                <span className="stat-label">Generaciones</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">Q</span>
                <span className="stat-label">Catador Q Grader</span>
              </div>
            </div>
          </div>
        </section>

        {/* Sección Imagen 360° */}
        <section className="panorama-section">
          <div className="panorama-container">
            <h2>Explora Nuestra Finca</h2>
            <p>Recorrido virtual 360° por nuestras instalaciones y cafetales</p>
            <Carrusel360 />
          </div>
        </section>

        {/* Sección de Videos */}
        <section className="videos-section">
          <div className="section-header">
            <h2>Conoce Nuestra Historia</h2>
            <p>Videos que muestran nuestra pasión por el café</p>
          </div>

          <div className="videos-grid">
            <div className="video-card">
              <div className="video-container">
                <video 
                  controls
                  preload="metadata"
                  className="video-player"
                >
                  <source src={vid1} type="video/mp4" />
                  Tu navegador no soporta el elemento de video.
                </video>
              </div>
              <div className="video-info">
                <h3>Recorrido por Nuestra Finca</h3>
                <p>Conoce el proceso tradicional del café en nuestras instalaciones</p>
              </div>
            </div>

            <div className="video-card">
              <div className="video-container">
                <video 
                  controls
                  preload="metadata"
                  className="video-player"
                >
                  <source src={vid2} type="video/mp4" />
                  Tu navegador no soporta el elemento de video.
                </video>
              </div>
              <div className="video-info">
                <h3>Cata de Café con Román</h3>
                <p>Aprende a identificar los mejores granos con nuestro experto</p>
              </div>
            </div>

            <div className="video-card">
              <div className="video-container">
                <video 
                  controls
                  preload="metadata"
                  className="video-player"
                >
                  <source src={vid3} type="video/mp4" />
                  Tu navegador no soporta el elemento de video.
                </video>
              </div>
              <div className="video-info">
                <h3>Cocina Tradicional de Humo</h3>
                <p>Técnica ancestral en ollas de barro que intensifica los sabores</p>
              </div>
            </div>

            <div className="video-card">
              <div className="video-container">
                <video 
                  controls
                  preload="metadata"
                  className="video-player"
                >
                  <source src={vid4} type="video/mp4" />
                  Tu navegador no soporta el elemento de video.
                </video>
              </div>
              <div className="video-info">
                <h3>De la Finca a tu Taza</h3>
                <p>Todo el proceso de producción de nuestro café premium</p>
              </div>
            </div>
          </div>
        </section>

        {/* Productos Destacados */}
        <section className="featured-products">
          <div className="section-header">
            <h2>Productos Destacados</h2>
            <p>Nuestra selección especial para ti</p>
          </div>

          <div className="products-grid">
            {featuredProducts.map(product => (
              <div key={product.id} className="product-card">
                <Link to={`/product/${product.id}`} className="product-link">
                  <div className="product-image-container">
                    <img src={product.imagen_portada} alt={product.nombre} className="product-image" />
                    <span className="product-badge">Destacado</span>
                  </div>
                  <div className="product-info">
                    <span className="product-category">{product.categoria}</span>
                    <h3 className="product-name">{product.nombre}</h3>
                    <p className="product-description">{product.descripcion_corta}</p>
                    <div className="product-footer">
                      <span className="product-price">${product.precio} MXN</span>
                      <span className="product-stock">Disponible</span>
                    </div>
                  </div>
                </Link>
                <button className="add-to-cart-btn-card">
                  <span>🛒</span>
                  Agregar
                </button>
              </div>
            ))}
          </div>

          <div className="section-footer">
            <Link to="/products" className="btn btn-primary">
              Ver Todos los Productos
            </Link>
          </div>
        </section>

        {/* Sección Sobre Nosotros */}
        <section className="about-section">
          <div className="about-container">
            <div className="about-content">
              <h2>NUESTRA HISTORIA</h2>
              <h3>Desde 1880, una tradición familiar</h3>
              <p>
                La familia Valderrábano inició en el cultivo de café desde <strong>1880</strong>, 
                convirtiéndose en una tradición familiar que se ha transmitido de generación en 
                generación hasta llegar a nuestros días.
              </p>
              <p>
                Hoy, <strong>ROMÁN VALDERRÁBANO, EL CATADOR</strong>, cuenta con la experiencia 
                ancestral de 5 generaciones, además de ser <strong>catador Q Grader</strong>, para 
                producir y procesar uno de los mejores cafés del Estado de Puebla en la 
                <strong> Sierra Norte de Xicotepec de Juárez, Pueblo Mágico</strong>.
              </p>
              <p>
                Nuestra <strong>Cocina Tradicional de Humo</strong> utiliza técnicas ancestrales 
                en ollas de barro que intensifican los sabores y conservan los nutrientes, 
                ofreciendo resultados únicos en nuestra gastronomía.
              </p>

              <div className="about-features">
                <div className="about-feature">
                  <span className="feature-icon">🌱</span>
                  <h4>1880 - 5 Generaciones</h4>
                  <p>Tradición cafetalera familiar</p>
                </div>
                <div className="about-feature">
                  <span className="feature-icon">🏺</span>
                  <h4>Cocina de Humo</h4>
                  <p>Técnica ancestral en barro</p>
                </div>
                <div className="about-feature">
                  <span className="feature-icon">🏆</span>
                  <h4>Q Grader</h4>
                  <p>Catador certificado</p>
                </div>
              </div>

              <div className="about-quote">
                <blockquote>
                  "El café no es solo un grano, es la historia de nuestra tierra y el humo de nuestros fogones ancestrales"
                </blockquote>
                <cite>- Román Valderrábano, El Catador</cite>
              </div>
            </div>

            <div className="about-image">
              <img 
                src={romanImg} 
                alt="Román Valderrábano, El Catador"
              />
              <div className="image-caption">
                Román Valderrábano, El Catador - Q Grader
              </div>
            </div>
          </div>
        </section>

        {/* Sección de Tour y Reservas */}
        <section id="tour" className="tour-section">
          <div className="tour-container">
            <div className="tour-header">
              <h2>Conoce Nuestro Recorrido</h2>
              <p>Vive el fascinante mundo del café en la Sierra Norte de Puebla</p>
            </div>

            <div className="tour-content">
              <div className="tour-info">
                <div className="tour-location">
                  <span>📍 Xicotepec de Juárez, Pueblo Mágico</span>
                  <span>🌲 Bosque Mesófilo de Montaña</span>
                </div>
                
                <h3>Tour Completo: $300 MXN por persona</h3>
                <p className="tour-description">
                  Nos encontramos en la Sierra Norte de Puebla, en las más altas montañas. 
                  Nuestro recorrido comienza en nuestra procesadora y finca, donde presenciamos un 
                  bosque mesófilo de montaña, clima ideal para producir uno de los mejores cafés del país.
                </p>
                
                <ul className="tour-features">
                  <li>
                    <span>🌿</span>
                    <div>
                      <strong>Recorrido por el cafetal <span className="tour-badge">$150 MXN</span></strong>
                      <p>Visita guiada por nuestras plantaciones en el bosque mesófilo, explicación del cultivo y proceso de tostado.</p>
                    </div>
                  </li>
                  <li>
                    <span>👃</span>
                    <div>
                      <strong>Taller de Catación <span className="tour-badge">$200 MXN</span></strong>
                      <p>Aprende a identificar notas y aromas con Román Valderrábano, catador Q Grader. Cata de 5 variedades.</p>
                    </div>
                  </li>
                  <li>
                    <span>🍽️</span>
                    <div>
                      <strong>Cocina Tradicional de Humo <span className="tour-badge">$200 MXN extra</span></strong>
                      <p>Experiencia gastronómica en ollas de barro con técnicas ancestrales de humo. Recetas familiares.</p>
                      <small>* Requiere mínimo 10 personas</small>
                    </div>
                  </li>
                </ul>

                <div className="tour-details">
                  <div className="detail-item">
                    <span className="detail-label">📍 Ubicación:</span>
                    <span className="detail-value">Xicotepec de Juárez, Puebla (Pueblo Mágico)</span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">🌲 Entorno:</span>
                    <span className="detail-value">Bosque mesófilo de montaña</span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">Duración:</span>
                    <span className="detail-value">4 horas</span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">Guía especializado:</span>
                    <span className="detail-value">Incluido</span>
                  </div>
                  <div className="detail-total">
                    Tour + Cocina de Humo (10+ personas): $500 MXN por persona
                  </div>
                </div>
              </div>

              <div className="tour-images">
                <img src={bosqueImg} alt="Bosque mesófilo" className="tour-image-main" />
                <div className="tour-images-grid">
                  <img src={fincaImg} alt="Finca cafetalera" />
                  <img src={cocinaHumoImg} alt="Cocina tradicional de humo" />
                </div>
              </div>

              <div className="tour-form">
                <h3>Reserva tu Experiencia</h3>
                <form onSubmit={handleTourSubmit}>
                  <div className="form-group">
                    <input
                      type="text"
                      name="name"
                      placeholder="Nombre completo"
                      value={formData.name}
                      onChange={(e) => setFormData({...formData, name: e.target.value})}
                      required
                    />
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <input
                        type="email"
                        name="email"
                        placeholder="Email"
                        value={formData.email}
                        onChange={(e) => setFormData({...formData, email: e.target.value})}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <input
                        type="tel"
                        name="phone"
                        placeholder="Teléfono"
                        value={formData.phone}
                        onChange={(e) => setFormData({...formData, phone: e.target.value})}
                        required
                      />
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <input
                        type="date"
                        name="date"
                        value={formData.date}
                        onChange={(e) => setFormData({...formData, date: e.target.value})}
                        min={new Date().toISOString().split('T')[0]}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <select
                        name="people"
                        value={formData.people}
                        onChange={(e) => setFormData({...formData, people: e.target.value})}
                      >
                        {[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15].map(num => (
                          <option key={num} value={num}>{num} {num === 1 ? 'persona' : 'personas'}</option>
                        ))}
                      </select>
                    </div>
                  </div>

                  <div className="form-group checkbox-group">
                    <label>
                      <input
                        type="checkbox"
                        name="includeCatacion"
                        checked={formData.includeCatacion}
                        onChange={(e) => setFormData({...formData, includeCatacion: e.target.checked})}
                      />
                      Incluir Taller de Catación ($200 MXN por persona)
                    </label>
                  </div>

                  <div className="form-group checkbox-group">
                    <label>
                      <input
                        type="checkbox"
                        name="includeRecorrido"
                        checked={formData.includeRecorrido}
                        onChange={(e) => setFormData({...formData, includeRecorrido: e.target.checked})}
                      />
                      Incluir Recorrido por el cafetal ($150 MXN por persona)
                    </label>
                  </div>

                  {formData.includeCatacion && formData.includeRecorrido && (
                    <div className="tour-completo-info">
                      ✨ Tour Completo: $300 MXN por persona (ahorras $50 MXN)
                    </div>
                  )}

                  <div className="form-group checkbox-group">
                    <label>
                      <input
                        type="checkbox"
                        name="includeBuffet"
                        checked={formData.includeBuffet}
                        onChange={(e) => setFormData({...formData, includeBuffet: e.target.checked})}
                      />
                      Agregar Cocina Tradicional de Humo ($200 MXN extra por persona)
                    </label>
                    {formData.includeBuffet && parseInt(formData.people) < 10 && (
                      <small className="form-hint">⚠️ La cocina de humo requiere mínimo 10 personas</small>
                    )}
                  </div>

                  <div className="form-group">
                    <textarea
                      name="message"
                      placeholder="Mensaje o requerimientos especiales (opcional)"
                      rows="3"
                      value={formData.message}
                      onChange={(e) => setFormData({...formData, message: e.target.value})}
                    ></textarea>
                  </div>

                  <button type="submit" className="btn-submit">
                    Reservar Ahora
                  </button>
                </form>
              </div>
            </div>
          </div>
        </section>

        {/* Sección de Café Verde por Tonelada */}
        <section className="wholesale-section">
          <div className="wholesale-container">
            <div className="wholesale-header">
              <h2>Venta de Café Verde por Tonelada</h2>
              <p>Para tostadores, importadores y productores</p>
            </div>

            <div className="wholesale-grid">
              <div className="wholesale-card">
                <span className="wholesale-icon">🚢</span>
                <h3>Exportación Directa</h3>
                <p>Sin intermediarios, garantizando el mejor precio y calidad.</p>
              </div>
              <div className="wholesale-card">
                <span className="wholesale-icon">📋</span>
                <h3>Trazabilidad Completa</h3>
                <p>Cada lote con certificado de origen y análisis de taza.</p>
              </div>
              <div className="wholesale-card">
                <span className="wholesale-icon">🌍</span>
                <h3>Certificaciones</h3>
                <p>Orgánico, Comercio Justo, Rainforest Alliance.</p>
              </div>
              <div className="wholesale-card">
                <span className="wholesale-icon">📦</span>
                <h3>Logística Integrada</h3>
                <p>Envíos a cualquier parte del mundo.</p>
              </div>
            </div>

            <div className="wholesale-cta">
              <p>¿Interesado en compras por tonelada?</p>
              <a href="#contacto-comercial" className="btn btn-primary btn-large" onClick={(e) => {
                e.preventDefault();
                document.getElementById('contacto-comercial')?.scrollIntoView({ behavior: 'smooth' });
              }}>
                Solicitar Cotización
              </a>
            </div>
          </div>
        </section>

        {/* Sección de Variedades de Café Verde */}
        <section className="green-coffee-section">
          <div className="green-coffee-container">
            <div className="green-coffee-header">
              <h2>Variedades de Café Verde</h2>
              <p>Seleccionamos los mejores granos de nuestras fincas y productores aliados</p>
            </div>

            <div className="coffee-varieties-grid">
              {greenCoffeeVarieties.map((variety, index) => (
                <div key={index} className="variety-card">
                  <h3>{variety.nombre}</h3>
                  <div className="variety-detail">
                    <strong>Origen:</strong> {variety.origen}
                  </div>
                  <div className="variety-detail">
                    <strong>Altitud:</strong> {variety.altitud}
                  </div>
                  <div className="variety-detail">
                    <strong>Perfil:</strong> {variety.perfil_taza}
                  </div>
                  <div className="variety-price">
                    Consultar
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Sección de Contacto Comercial */}
        <section id="contacto-comercial" className="contacto-comercial">
          <div className="contacto-comercial-grid">
            <div className="contacto-info">
              <h2>Contacto para Ventas por Tonelada</h2>
                <p className="contacto-subtitle">
                  Nuestro equipo comercial te responderá en máximo 24 horas
                </p>

                <div className="contacto-metodos">
                  <div className="metodo">
                    <span className="metodo-icon">📞</span>
                    <div>
                      <h4>Teléfono Comercial</h4>
                      <p>+52 (228) 123-4567</p>
                    </div>
                  </div>
                  
                  <div className="metodo">
                    <span className="metodo-icon">✉️</span>
                    <div>
                      <h4>Email Corporativo</h4>
                      <p>ventas@cafeelcatador.com</p>
                    </div>
                  </div>
                  
                  <div className="metodo">
                    <span className="metodo-icon">💬</span>
                    <div>
                      <h4>WhatsApp Business</h4>
                      <p>+52 228 123 4567</p>
                    </div>
                  </div>
                  
                  <div className="metodo">
                    <span className="metodo-icon">⏰</span>
                    <div>
                      <h4>Horario de Atención</h4>
                      <p>Lunes a Viernes: 8am - 6pm</p>
                      <p>Sábados: 9am - 2pm</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="contacto-form">
                <h3>Solicita tu Cotización</h3>
                <form onSubmit={handleContactSubmit}>
                  <div className="form-group">
                    <input
                      type="text"
                      name="name"
                      placeholder="Nombre completo *"
                      value={contactData.name}
                      onChange={(e) => setContactData({...contactData, name: e.target.value})}
                      required
                    />
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <input
                        type="email"
                        name="email"
                        placeholder="Email *"
                        value={contactData.email}
                        onChange={(e) => setContactData({...contactData, email: e.target.value})}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <input
                        type="text"
                        name="company"
                        placeholder="Empresa"
                        value={contactData.company}
                        onChange={(e) => setContactData({...contactData, company: e.target.value})}
                      />
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <input
                        type="tel"
                        name="phone"
                        placeholder="Teléfono *"
                        value={contactData.phone}
                        onChange={(e) => setContactData({...contactData, phone: e.target.value})}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <select
                        name="tonnage"
                        value={contactData.tonnage}
                        onChange={(e) => setContactData({...contactData, tonnage: e.target.value})}
                      >
                        <option value="1">1 tonelada (muestra)</option>
                        <option value="5">5 toneladas</option>
                        <option value="10">10 toneladas</option>
                        <option value="20">20 toneladas</option>
                        <option value="50">50 toneladas</option>
                        <option value="100">100+ toneladas</option>
                      </select>
                    </div>
                  </div>

                  <div className="form-group">
                    <select
                      name="quality"
                      value={contactData.quality}
                      onChange={(e) => setContactData({...contactData, quality: e.target.value})}
                      required
                    >
                      <option value="">Selecciona calidad *</option>
                      <option value="superior">Oro Natural Superior</option>
                      <option value="pl10">Oro PL-10</option>
                      <option value="pl20">Oro PL-20</option>
                      <option value="altura">Altura Premium</option>
                      <option value="especialidad">Café de Especialidad (85+ puntos)</option>
                      <option value="gourmet">Gourmet (90+ puntos)</option>
                    </select>
                  </div>

                  <div className="form-group">
                    <textarea
                      name="message"
                      placeholder="Requerimientos específicos (opcional)"
                      rows="4"
                      value={contactData.message}
                      onChange={(e) => setContactData({...contactData, message: e.target.value})}
                    ></textarea>
                  </div>

                  <button type="submit" className="btn-submit">
                    Solicitar Cotización
                  </button>
                </form>
              </div>
            </div>
          </section>

        {/* Sección de Mapa */}
        <section className="mapa-section">
          <div className="mapa-container">
            <h2>Visítanos en la Sierra Norte de Puebla</h2>
            <p>Xicotepec de Juárez - Pueblo Mágico</p>

            <div className="mapa-wrapper">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1880.387450255424!2d-97.964414!3d20.275843!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d085564fd3d265%3A0xf644826230ec25e5!2sZaragoza%20146%2C%20Centro%2C%2073080%20Xicotepec%20de%20Ju%C3%A1rez%2C%20Pue.!5e0!3m2!1ses-419!2smx!4v1700000000000!5m2!1ses-419!2smx"
                title="Ubicación de Román Valderrábano El Catador en Xicotepec"
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
              <div className="mapa-overlay">
                <h3>Román Valderrábano El Catador</h3>
                <p>Zaragoza 146, Centro, Xicotepec de Juárez, Pue.</p>
                <p>Sierra Norte de Puebla - Pueblo Mágico</p>
              </div>
            </div>

            <div className="mapa-info">
              <div className="mapa-info-item">
                <span>📍</span>
                <span>Zaragoza 146, Centro</span>
              </div>
              <div className="mapa-info-item">
                <span>⏰</span>
                <span>Lun-Sáb: 8am - 6pm</span>
              </div>
              <div className="mapa-info-item">
                <span>📞</span>
                <span>+52 228 123 4567</span>
              </div>
            </div>
          </div>
        </section>

        {/* Sección de Testimonios */}
        <section className="testimonials-section">
          <div className="testimonials-container">
            <h2>Lo que dicen nuestros clientes</h2>

            <div className="testimonials-grid">
              <div className="testimonial-card">
                <p className="testimonial-text">
                  "El café de Román tiene una consistencia increíble. Llevamos 5 años comprándoles café verde por tonelada y nunca nos han decepcionado. La trazabilidad es excepcional."
                </p>
                <div className="testimonial-author">
                  <strong>Juan Carlos Hernández</strong>
                  <span>Tostador Artesanal, CDMX</span>
                </div>
              </div>

              <div className="testimonial-card">
                <p className="testimonial-text">
                  "El tour por la finca fue una experiencia transformadora. Ver el proceso de primera mano y probar la cocina tradicional de humo cambió mi perspectiva del café. ¡Volveré cada año!"
                </p>
                <div className="testimonial-author">
                  <strong>María Fernanda López</strong>
                  <span>Barista, Guadalajara</span>
                </div>
              </div>

              <div className="testimonial-card">
                <p className="testimonial-text">
                  "Como importador, valoro la honestidad y calidad de Román Valderrábano, El Catador. Sus lotes de Oro PL-20 son consistentes y el perfil de taza es exactamente lo que buscan mis clientes en Europa."
                </p>
                <div className="testimonial-author">
                  <strong>Carlos Mendoza</strong>
                  <span>Importador, Barcelona</span>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Home;